"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var QuizTogether = function QuizTogether(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0.25C21.209 0.25 23 2.04097 23 4.25V5C23 7.12167 21.3435 8.871 19.2051 8.99449L19 9C16.791 9 15 7.20903 15 5V4.25C15 2.04097 16.791 0.25 19 0.25ZM19 2.25C17.8955 2.25 17 3.14554 17 4.25V5C17 6.10447 17.8955 7 18.9711 7.00042L19.1184 6.99658C20.1714 6.93556 21 6.06056 21 5V4.25C21 3.14554 20.1045 2.25 19 2.25ZM12 6.25001C12 4.04097 10.209 2.25 8.00001 2.25C5.79097 2.25 4.00001 4.04097 4.00001 6.25001V7.00001C4.00001 9.20904 5.79097 11 8.00001 11L8.20515 10.9945C10.3435 10.871 12 9.12168 12 7.00001V6.25001ZM6 6.25001C6 5.14554 6.89554 4.25001 8 4.25001C9.10447 4.25001 10 5.14554 10 6.25001V7.00001C10 8.06057 9.17143 8.93557 8.11841 8.99659L7.97112 9.00043C6.89554 9.00001 6 8.10448 6 7.00001V6.25001ZM21 13H17C16.4477 13 16 12.5523 16 12C16 11.4477 16.4477 11 17 11H21C24.314 11 27 13.6864 27 17C27 18.6563 25.6563 20 24 20H20C19.4477 20 19 19.5523 19 19C19 18.4477 19.4477 18 20 18H24C24.5517 18 25 17.5517 25 17C25 14.7909 23.2093 13 21 13ZM10 13C13.314 13 16 15.6864 16 19C16 20.6563 14.6563 22 13 22H3C1.34372 22 0 20.6563 0 19C0 15.6867 2.68672 13 6 13H10ZM9.99999 15H5.99999C3.79128 15 1.99999 16.7913 1.99999 19C1.99999 19.5517 2.44828 20 2.99999 20H13C13.5517 20 14 19.5517 14 19C14 16.7909 12.2093 15 9.99999 15Z",
    fill: color
  }));
};
var _default = QuizTogether;
exports.default = _default;